<template>
  <div class="page">
   <div class="bg-white " style="height: calc(100%);">
    <el-card>
      <el-form size="small"  class="" ref="searchForm" :model="detForm">
        <el-form-item prop="" label="项目编号：">
          <span>{{ detForm.project.proCode }}</span>
        </el-form-item>
        <el-form-item prop="" label="项目名称：">
          <span>{{ detForm.project.name }}</span>
        </el-form-item>
        <el-form-item prop="" label="项目单价：">
          <span>$ {{ $mathUtil.mathToFixed(detForm.price) }} / {{ detForm.unitEn }}</span>
        </el-form-item>
        <el-form-item prop="" label="备注信息：">
          <span>{{ detForm.description }}</span> 
        </el-form-item>
      </el-form>
    </el-card>
      <div class="tableTitle">材料方案：</div>
      <div style="min-height: calc(50% - 20px);">
      <vxe-table
          border="full"
          auto-resize
          resizable
          height="auto"
          :loading="loading"
          size="small"
          ref="cecUnmSetsTable"
          show-header-overflow
          show-overflow
          highlight-hover-row
          :menu-config="{}"
          :print-config="{}"
          :import-config="{
          importMethod: importMethod,
              types: ['csv', 'xls', 'xlsx'],
              remote: true,
          }"
          :export-config="{
              remote: true,
              filename: `套餐表数据${moment(new Date()).format(
              'YYYY-MM-DD'
              )}`,
              sheetName: '套餐表数据',
              exportMethod: exportMethod,
              types: ['xlsx'],
              modes: ['current', 'selected', 'all'],
          }"
          @sort-change="sortChangeHandle"
          :sort-config="{remote:true}"
          :data="dataList"
          :checkbox-config="{}">
          <!-- <vxe-column type="seq" width="40"></vxe-column> -->
          <!-- <vxe-column type="checkbox"  width="40px"></vxe-column> -->
          <!-- <vxe-column
      field="sort"
      width="50px"
      title="排序">
    </vxe-column> -->
    <vxe-column
      field="mateKind"
      width="100"
      align="center"
      title="材料使用">
        <template slot-scope="scope">
          <span>{{ scope.row.mateKind }}</span>   
        </template>
    </vxe-column>
    <vxe-column
      field="code"
      align="center"
      width="100"
      title="物品编码">
        <template slot-scope="scope">
            <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('unmsets:cecUnmSets:edit')" @click="edit(scope.row.id)">{{scope.row.nameCn}}</el-link> -->
            <el-link  type="primary" :underline="false" v-if="hasPermission('cecitem:cecItem:view')"  @click="view(scope.row)">{{scope.row.item ? scope.row.item.code : ''}}</el-link>
            <span v-else>{{scope.row.item ? scope.row.item.code :''}}</span>
          </template>
    </vxe-column>
  <vxe-column
      field="nameCn"
      align="center"
      show-overflow
      title="中文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.nameCn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.nameCn : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.name : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.name : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
  <vxe-column
      field="name"
      align="center"
      title="英文名称">
      <template slot-scope="scope">
          <el-tooltip v-if="scope.row.itemId" class="item" effect="dark" :content="scope.row.item ? scope.row.item.name :''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.name : '' }}</div>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.category ? scope.row.category.nameEn : ''" placement="top">
            <div class="textOverflow">{{ scope.row.category ? scope.row.category.nameEn : '' }}</div>
          </el-tooltip>
        </template>
    </vxe-column>
    <vxe-column
        field="name"
        align="center"
        width="100"
        title="材料类别">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.item ? scope.row.item.category.parentIdsName : ''" placement="top">
            <div class="textOverflow">{{ scope.row.item ? scope.row.item.category.name : '' }}</div>
          </el-tooltip>
        </template>
      </vxe-column>
      <vxe-column
      field="num"
      align="center"
      width="100"
      title="单价">
      <template slot-scope="scope">
        <div class="flexBetween">
          <span>$</span>
          <div v-if="scope.row.item">
            <span>{{ scope.row.price }} / </span>   
            <span>{{ scope.row.item.units ? scope.row.item.units.unitEn : '' }}</span>
          </div>
        </div>
        </template>
    </vxe-column>
      
  <!-- <vxe-column
      field="minUsage"
      align="center"
      title="面积/数量">
    </vxe-column> -->
    <vxe-column
      field="rateNum"
      width="100"
      align="center"
      title="损耗率">
        <template slot-scope="scope">
          <span>{{ scope.row.rateNum }}%</span>
        </template>
    </vxe-column>
  <vxe-column
      field="rateDesc"
      align="center"
      title="损耗率描述">
    </vxe-column>
  </vxe-table>
  </div>
  </div>
      <!-- 弹窗, 新增 / 修改 -->
  <CecItemForm  ref="cecItemForm" @refreshDataList="refreshList"></CecItemForm>
</div>
</template>

<script>
import CecItemForm from '../cecitem/CecItemForm.vue'
import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
import cecUnmProjectPositionProjectService from '@/api/unmprojectpositionproject/cecUnmProjectPositionProjectService'
import ItemService from '@/api/unmprojectpositionprojectitem/cecUnmProjectPositionProjectItemService'
export default {
  data () {
    return {
      detForm: {
        unitEn: '',
        price: 0,
        description: '',
        unitCn: '',
        project: {
          proCode: '',
          name: ''
        }
      },
      dataList: [],
      tablePage: {
        orders: [{ column: 'sort', asc: false }]
      },
      loading: false,
      projectId: ''
    }
  },
  components: {
    CecItemForm
  },
  activated () {
    this.projectId = this.$route.query.id
    this.refreshList()
  },
  methods: {
    // 跳转套餐项目列表
    handSetsProject () {

    },
    // 获取cec套餐表数据
    getCecProject () {
      this.loading = true
      cecUnmSetsService.getCecProject({}).then(({res}) => {
        this.refreshList()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取数据列表
    refreshList () {
      this.loading = true
      cecUnmProjectPositionProjectService.queryById(this.projectId).then(({data}) => {
        // this.inputForm = this.recover(this.inputForm, data)
        this.detForm = data
        this.detForm.unitCn = data.project.unit ? data.project.unit.unit : ''
        this.detForm.unitEn = data.project.unit ? data.project.unit.unitEn : ''
        this.loading = false
      })
      ItemService.list({
        positionProjectId: this.projectId,
        orders: [{ column: 'mate_kind', asc: true }],
        current: 1,
        size: 100
      }).then(({data}) => {
        this.dataList = data.records
      })
    },
    // 当前页
    currentChangeHandle ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.refreshList()
    },
    // 排序
    sortChangeHandle (obj) {
      this.tablePage.orders = []
      if (obj.order != null) {
        this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
      } else {
        this.tablePage.orders = [{ column: 'create_date', asc: false }]
      }
      this.refreshList()
    },
    // 新增
    add () {
      this.$refs.cecUnmSetsForm.init('add', '')
    },
    // 修改
    edit (id) {
      id = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      })[0]
      this.$refs.cecUnmSetsForm.init('edit', id)
    },
    // 查看
    view (data) {
      let query = {
        id: data.itemId,
        parentCode: ''
      }
      this.$refs.cecItemForm.init('view', query)
    },
    // 删除
    del (id) {
      let ids = id || this.$refs.cecUnmSetsTable.getCheckboxRecords().map(item => {
        return item.id
      }).join(',')
      this.$confirm(`确定删除所选项吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        cecUnmSetsService.delete(ids).then(({data}) => {
          this.$message.success(data)
          this.refreshList()
          this.loading = false
        })
      })
    },
    // 下载模板
    downloadTpl () {
      this.loading = true
      cecUnmSetsService.exportTemplate().then(({data}) => {
  // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, '请假表单导入模板')
        this.loading = false
      }).catch(function (err) {
        this.loading = false
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    // 自定义服务端导入
    importMethod ({ file }) {
    // 处理表单
      const formBody = new FormData()
      formBody.append('file', file)
      this.loading = true
      cecUnmSetsService.importExcel(formBody).then(({data}) => {
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: data
        })
        this.refreshList()
      })
    },
    // 自定义服务端导出
    exportMethod ({ options }) {
    // 传给服务端的参数
      const params = {
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        orders: this.tablePage.orders,
        ...this.searchForm,
        filename: options.filename,
        sheetName: options.sheetName,
        isHeader: options.isHeader,
        original: options.original,
        mode: options.mode,
        selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
        exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
      }
      this.loading = true
      return cecUnmSetsService.exportExcel(params).then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
        this.$utils.downloadExcel(data, options.filename)
        this.loading = false
      }).catch(function (err) {
        if (err.response) {
          console.log(err.response)
        }
      })
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.refreshList()
    }
  }
}
</script>
<style scoped>
.tableTitle{
  padding: 20px 0 10px 0;
  font-weight: bold;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

